import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDatabaseCertificationParams {
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetDatabaseCertificationRequest extends Request<IDatabaseCertificationParams, IResult> {
  constructor(params: IDatabaseCertificationParams) {
    super('setDatabaseCertification', params);
  }
}
